import Vue from 'vue'
import VueRouter from 'vue-router'

import RouterView from "@/view/RouterView.vue";

const defLangUrl = 'hu'
var langsArray = ['hu', 'en', 'ru']

Vue.use(VueRouter)

var routes = []

routes = [
    {          
      path: '/Receptek',
      redirect: {path: '/hu/receptek'}
    },   
    {
      path: '',          
      redirect: {name: 'Home'}
    },
    {
      path: "/:lang",
      component: RouterView,
      beforeEnter(to, from, next) {    
        const lang = to.params.lang;  
        if (!langsArray.includes(lang)) return next(defLangUrl)
        return next()                            
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/pages/HomePage.vue')
        },     
        {
          path: 'termekek',
          name: 'Products_hu',    
          component: () => import('@/pages/Products.vue'),                   
        },
        {
          name: 'ProductsCategoryList_hu',
          path: 'termekek/:product_category_slug',
          component: () => import('@/pages/ProductsCategoryList.vue')          
        },
        {
          name: 'ProductDetails_hu',
          path: 'termekek/:product_category_slug/:product_slug',
          component: () => import('@/pages/ProductDetails.vue') 
        },
        {
          path: 'products',
          name: 'Products_en',    
          component: () => import('@/pages/Products.vue')
        },
        {
          name: 'ProductsCategoryList_en',
          path: 'products/:product_category_slug',
          component: () => import('@/pages/ProductsCategoryList.vue')          
        },
        {
          name: 'ProductDetails_en',
          path: 'products/:product_category_slug/:product_slug',
          component: () => import('@/pages/ProductDetails.vue') 
        },
        {
          name: 'Products_ru', 
          path: 'products',             
          component: () => import('@/pages/Products.vue')
        },
        {
          name: 'ProductsCategoryList_ru',
          path: 'products/:product_category_slug',
          component: () => import('@/pages/ProductsCategoryList.vue') 
        },
        {
          name: 'ProductDetails_ru',
          path: 'products/:product_category_slug/:product_slug',
          component: () => import('@/pages/ProductDetails.vue') 
        },
        {
          name: 'RecipesCategoryListAll_hu',
          path: 'receptek',
          component: () => import('@/pages/RecipesCategoryList.vue')      
        },
        {
          name: 'RecipesCategoryList_hu',
          path: 'receptek/:recipes_category_slug',
          component: () => import('@/pages/RecipesCategoryList.vue')        
        },
        {
          name: 'RecipeDetails_hu',
          path: 'receptek/:recipes_category_slug/:recipe_slug',
          component: () => import('@/pages/RecipeDetails.vue') 
        },
        {
          name: 'RecipesCategoryListAll_en',
          path: 'recipes',
          component: () => import('@/pages/RecipesCategoryList.vue')          
        },
        {
          name: 'RecipesCategoryList_en',
          path: 'recipes/:recipes_category_slug',
          component: () => import('@/pages/RecipesCategoryList.vue')    
        },
        {
          name: 'RecipeDetails_en',
          path: 'recipes/:recipes_category_slug/:recipe_slug',
          component: () => import('@/pages/RecipeDetails.vue') 
        },   
        {
          name: 'RecipesCategoryListAll_ru',
          path: 'recipes',
          component: () => import('@/pages/RecipesCategoryList.vue')          
        },
        {
          name: 'RecipesCategoryList_ru',
          path: 'recipes/:recipes_category_slug',
          component: () => import('@/pages/RecipesCategoryList.vue')    
        },
        {
          name: 'RecipeDetails_ru',
          path: 'recipes/:recipes_category_slug/:recipe_slug',
          component: () => import('@/pages/RecipeDetails.vue') 
        },     
        {
          name: 'NewsAll_hu',
          path: 'aktualis',
          component: () => import('@/pages/NewsCategoryList.vue') 
        },
        {
          name: 'News_hu',
          path: 'aktualis/:news_category_slug',
          component: () => import('@/pages/NewsCategoryList.vue') 
        },
        {
          name: 'NewsDetails_hu',
          path: 'aktualis/:news_category_slug/:news_slug',
          component: () => import('@/pages/NewsDetails.vue') 
        },
        {
          name: 'NewsAll_en',
          path: 'news',
          component: () => import('@/pages/NewsCategoryList.vue') 
        },
        {
          name: 'News_en',
          path: 'news/:news_category_slug',
          component: () => import('@/pages/NewsCategoryList.vue') 
        },
        {
          name: 'NewsDetails_en',
          path: 'news/:news_category_slug/:news_slug',
          component: () => import('@/pages/NewsDetails.vue') 
        }, 
        {
          name: 'NewsAll_ru',
          path: 'novosti',
          component: () => import('@/pages/NewsCategoryList.vue') 
        },
        {
          name: 'News_ru',
          path: 'novosti/:news_category_slug',
          component: () => import('@/pages/NewsCategoryList.vue') 
        },
        {
          name: 'NewsDetails_ru',
          path: 'novosti/:news_category_slug/:news_slug',
          component: () => import('@/pages/NewsDetails.vue') 
        },
        {
          name: 'Career_hu',
          path: 'karrier',
          component: () => import('@/pages/Career.vue')
        }, 
        {
          name: 'CareerDetails_hu',
          path: 'karrier/:career_slug',          
          component: () => import('@/pages/CareerDetails.vue')
        },
        {
          name: 'CareerApply_hu',
          path: 'karrier/:career_slug/jelentkezesi_lap',          
          component: () => import('@/pages/CareerApplyForm.vue')
        },
        {
          name: 'Career_en',
          path: 'career',
          component: () => import('@/pages/Career.vue')
        }, 
        {
          name: 'CareerDetails_en',
          path: 'career/:career_slug',          
          component: () => import('@/pages/CareerDetails.vue')
        },
        {
          name: 'CareerApply_en',
          path: 'career/:career_slug/jelentkezesi_lap',          
          component: () => import('@/pages/CareerApplyForm.vue')
        },
        {
          name: 'Career_ru',
          path: 'karera',
          component: () => import('@/pages/Career.vue')
        }, 
        {
          name: 'CareerDetails_ru',
          path: 'karera/:career_slug',          
          component: () => import('@/pages/CareerDetails.vue')
        },
        {
          name: 'CareerApply_ru',
          path: 'karera/:career_slug/jelentkezesi_lap',          
          component: () => import('@/pages/CareerApplyForm.vue')
        },
        {
          name: 'StaticPage_hu',
          path: 'informacio/:info_slug',          
          component: () => import('@/pages/staticpages/StaticPage.vue')          
        },
        {
          name: 'StaticPage_en',
          path: 'information/:info_slug',          
          component: () => import('@/pages/staticpages/StaticPage.vue')          
        },
        {
          name: 'StaticPage_ru',
          path: 'informacio/:info_slug',          
          component: () => import('@/pages/staticpages/StaticPage.vue')          
        },                
        {
          name: 'SearchResult_hu',
          path: 'kereses',          
          component: () => import('@/pages/SearchResult.vue')
        },
        {
          name: 'SearchResult_en',
          path: 'search',          
          component: () => import('@/pages/SearchResult.vue')
        },
        {
          name: 'SearchResult_ru',
          path: 'poisk',          
          component: () => import('@/pages/SearchResult.vue')
        },   
        {
          name: 'Newsletter_signDown',
          path: 'leiratkozas_hirlevelrol/:id',          
          component: () => import('@/pages/NewslwetterSignDown.vue')
        },     
        {
          name: 'UniverGroup',
          path: ':main_group',          
          component: () => import('@/pages/UniverGroup.vue')
        }, 
        {
          name: 'UniverGroupSubCategoryPage',
          path: ':main_group/:group_slug',          
          component: () => import('@/pages/UniverGroupSubCategoryPage.vue')
        },
        {
          name: 'UniverGroupDetails',
          path: ':main_group/:group_slug/:group_details_slug',          
          component: () => import('@/pages/UniverGroupDetails.vue')
        },                          
        {
          path: '404',
          name: '404-page',          
          component: () => import('@/pages/PageNotFound.vue'),
          meta: { layout: 'empty-layout'}
        },     
        {
          // 404 page
          path: "*",
          redirect: '404'         
        }
      ]
    },
    // {
    //   path: '404-2',
    //   name: '404-page',          
    //   component: () => import('@/pages/PageNotFound.vue'),
    //   meta: { layout: 'empty-layout'}
    // },
    // {
    //   // 404 page
    //   path: "*",
    //   redirect: '404-2'         
    // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.afterEach(() => {
  window.scrollTo(0, 0);
})

export default router
